<template lang="pug">
    div
        PmContentBox(:content="lenguageSelected.contentBox")
        .container
            .row.careers
                .col-md-12.products-template-content.no-margin-bottom
                    div
                        p   {{ lenguageSelected.content1 }}
                        p
                            b   {{ lenguageSelected.content2 }}
                            |   {{ lenguageSelected.content3 }}
                        p
                            b   {{ lenguageSelected.content4 }}
                            |   {{ lenguageSelected.content5 }}
                .col-md-8
                    form#contact-work(action="/contact/send-email")
                        .careers-group(v-for="(item, index) in lenguageSelected.content6")
                            .careers-label {{ item.title }}
                            input(:name="item.name", type="text", v-model="form.data[index]", @keyup="validateInputs", @keydown="validateInputs")
                            span.error(:style="error.data[index]? 'opacity: 1' : 'opacity: 0'") {{lenguageSelected.error2}}
                        .careers-group
                            .careers-label {{ lenguageSelected.content7.name }}
                            select(name="country", v-model="form.form_country", @change="validateInputs")
                                option(value="", style="display:none") {{ lenguageSelected.content7.none }}
                                option(v-for="item in lenguageSelected.content7.countries", :value="item") {{ item }}
                        .careers-group
                            .careers-label {{ lenguageSelected.content8.title }}
                            input#file.no-border(type="file", @change="changeFiles", ref="miarchivo")
                            .careers-ht {{ lenguageSelected.content8.warn }}
                                span    2 MB
                            .careers-ht {{ lenguageSelected.content8.types }}
                                span    pdf doc docx.
                        .careers-group
                            // VueRecaptcha(sitekey="6LfDsaoUAAAAALB1UYBBVACxfcYMZZXSePTo5LW-", :loadRecaptchaScript="true")
                        .button-toggle
                            button.button-submit(type="submit", @click.prevent="sendData", v-if="sendState == 'normal'") {{ lenguageSelected.content9 }}
                            button.btn-inactive(@click.prevent="", v-if="sendState == 'loading'")
                                i.fas.fa-circle-notch
                        .message-send-finish(v-if="sendState == 'finish'")
                                |   {{lenguageSelected.contactText}}
                .col-md-4
                    //.careers-title(style="text-align:center") {{ lenguageSelected.content10 }}
                    //.careers-list(style="text-align:center")
                        ul
                            li
                                router-link(:to="lenguage == 'EN'? '/en/careers/sales-manager' : '/es/oportunidades/sales-manager'")  {{ lenguageSelected.content11.country }}
                                    strong(style="font-family: 'Futura Bolder'!important;") {{ lenguageSelected.content11.position }}
                    //div(style="text-align:center")
                        |   {{ lenguageSelected.content12 }}
</template>

<script>
import PmContentBox from '@components/atoms/PmContentBox.vue'
import axios from 'axios'
import { isEmpty } from 'lodash'
import VueRecaptcha from 'vue-recaptcha';
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    components: {
        PmContentBox, VueRecaptcha
    },
    methods:{
        changeFiles: function(){
            console.log(this.$refs.miarchivo.files[0])
        },
        sendData: function(){
            this.$data.isactivated = true
            this.validateData()
            var validate = this.validateData()
            if(validate){
                this.$data.sendState = 'loading'
                var country = this.$data.form.form_country; //name
                var firstName = this.$data.form.data[0]; //name
                var lastName = this.$data.form.data[1]; //street
                var phone = this.$data.form.data[2]; //city
                var email = this.$data.form.data[3]; //email
                var position = this.$data.form.data[4]; //email

                var file = this.$refs.miarchivo.files[0]

                var formBody = `    <!DOCTYPE html>
                    <html style="background-color: #EEE;">
                    <head>
                        <meta charset="utf-8">
                        <title>ATP - CONTACT</title>
                    </head>
                    <body style="width: 600px; padding: 24px; margin: 0 auto; background-color: #FFF;">
                        <table style="border-collapse: collapse; table-layout: fixed; width: 600px; margin: 0 auto; color: #545454; font-family: sans-serif; font-size: 14px;">
                            <tbody>
                                <tr>
                                    <td>
                                        <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <img height="100" style="vertical-align: top;" src="https://devwebsiteatp.azurewebsites.net/images/logo.png" alt="ATP LOGO">
                                                    </td>
                                                </tr>
                                                <tr><td style="height: 24px;"></td></tr>
                                                <tr>
                                                    <td style="font-size: 16px;">
                                                        This email was sent from the careers section of the web of ATP
                                                    </td>
                                                </tr>
                                                </tr>
                                                <tr><td style="height: 6px;"></td></tr>
                                            </tbody>
                                        </table>
                                        <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                                            <tbody>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Country:  ${country}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">First Name:  ${firstName}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Last Name:  ${lastName}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Phone Number:  ${phone}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Email:  ${email}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="width: 389px; padding: 10px; border: 1px solid #EEE;">Position:  ${position}</td>
                                                </tr>
                                                <tr><td style="height: 24px;" colspan="2"></td></tr>
                                            </tbody>
                                        </table>
                                        <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                                            <tbody>
                                                <tr><td style="height: 24px;"></td></tr>
                                                <tr>
                                                    <td style="font-size: 10px; text-align: center;">
                                                        ATP Sites 2018 | Powered by Massive Dynamics Peru
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </body>
                    </html>
        `
                var formSend = new FormData();
                formSend.append('html', formBody);
                formSend.append('file', file)
                formSend.append('country', country)

                axios.post('/api/action/email-careers', formSend)

                this.$data.sendState = 'finish'
            }
        },
        validateInputs: function(){
            if(this.$data.isactivated){
                this.validateData();
            }
        },
        validateData: function(){
            var validate = true

            if(isEmpty(this.$data.form.form_country)){
                this.$data.error.form_country = true
                validate = false
            }else{
                this.$data.error.form_country = false
            }

            if(isEmpty(this.$data.form.data[0])){
                this.$data.error.data[0] = true
                validate = false
            }else{
                this.$data.error.data[0] = false
            }

            if(isEmpty(this.$data.form.data[1])){
                this.$data.error.data[1] = true
                validate = false
            }else{
                this.$data.error.data[1] = false
            }

            if(isEmpty(this.$data.form.data[2])){
                this.$data.error.data[2] = true
                validate = false
            }else{
                this.$data.error.data[2] = false
            }

            if(isEmpty(this.$data.form.data[3])){
                this.$data.error.data[3] = true
                validate = false
            }else{
                this.$data.error.data[3] = false
            }

            if(isEmpty(this.$data.form.data[4])){
                this.$data.error.data[4] = true
                validate = false
            }else{
                this.$data.error.data[4] = false
            }
            return validate
        }
    },
    data: function(){
        return {
            sendState: 'normal',
            isactivated: false,
            file: '',
            form: {
                form_country: "",
                data: [],
            },

            error: {
                form_country: false,
                data: [],
            },



            lenguage: 'EN',
            lenguageEN: {
                error: 'At least select an option',
                error2: 'complete correctly',
                contactText: 'Thank you for contacting us, we will be contacting you soon. ',
                contentBox: 'ATP has enjoyed tremendous growth in recent years. Our employees work collaboratively throughout our vast geography to provide our clients with critical services and solutions',
                content1: "If you have the desire to contribute to the success of a high-growth telecommunications infrastructure company, consider joining ATP. We offer a fast-paced work environment where you'll have the chance to make an impact and expand your skills.",
                content2: 'Our Culture',
                content3: '- We work collaboratively in an environment of mutual respect, honesty and integrity. We care about the growth and development of our people, our clients and our communities. Our employees are our greatest asset, and together we make ATP an exciting place to work.',
                content4: 'Current Opportunities',
                content5: '- We are always looking for talented individuals seeking new challenges. To apply for an open position, complete the form below.',
                content6: [
                    {title: 'First Name', name: 'first_name', class: 'first-name'},
                    {title: 'Last Name', name: 'last_name', class: 'error-lastname'},
                    {title: 'Phone', name: 'phone', class: 'error-phone'},
                    {title: 'Email', name: 'email', class: 'error-email'},
                    {title: 'Position Applying For', name: 'position', class: 'error-position'},
                ],
                content7: {
                    name: 'Country',
                    none: 'Select a country',
                    countries: [
                        'Peru',
                        'Chile',
                        'Colombia',
                        'Ecuador',
                        'USA'
                    ],
                },
                content8: {
                    title: 'Resume',
                    warn: 'Files must be less than',
                    types: 'Allowed file types:'
                },
                content9: 'SUBMIT',
                content10: 'Current Openings',
                content11: {
                    country: 'Colombia -',
                    position: 'Sales Manager',
                    link: 'Current Openings'
                },
                content12: 'Spanish Fluency Required'
            },

            lenguageES: {
                error: 'Elija al menos una opcion de las anteriores.',
                error2: 'Complete correctamente.',
                contactText: 'Gracias por contactarnos, nos comunicaremos contigo pronto. ',
                contentBox: 'En los últimos años, ATP ha disfrutado de un tremendo crecimiento. Nuestros empleados trabajan juntos a través de nuestra vasta geografía para brindar servicios y soluciones a todos nuestros clientes.',
                content1: "Si usted tiene el deseo de contribuir al éxito de una empresa de infraestructura de telecomunicaciones de alto crecimiento, considere unirse a ATP. Ofrecemos un entorno de trabajo acelerado en el que tendrá la oportunidad de impactar y ampliar sus habilidades.",
                content2: 'Nuestra cultura',
                content3: '- Trabajamos en colaboración en un entorno de respeto mutuo, honestidad e integridad. Nos preocupamos por el crecimiento y desarrollo de nuestra gente, nuestros clientes y nuestras comunidades. Los empleados son nuestro mayor activo, y juntos hacemos de ATP un lugar emocionante para trabajar.',
                content4: 'Oportunidades actuales',
                content5: '- Siempre nos interesa conversar con personas con talento que buscan nuevos desafíos. Para ser considerando por una posición abierta, complete el siguiente formulario.',
                content6: [
                    {title: 'Nombre de pila', name: 'first_name', class: 'first-name'},
                    {title: 'Apellido', name: 'last_name', class: 'error-lastname'},
                    {title: 'Número de teléfono', name: 'phone', class: 'error-phone'},
                    {title: 'Email', name: 'email', class: 'error-email'},
                    {title: 'Posición solicitada', name: 'position', class: 'error-position'},
                ],
                content7: {
                    name: 'País',
                    none: 'Seleccione un país',
                    countries: [
                        'Perú',
                        'Chile',
                        'Colombia',
                        'Ecuador',
                        'USA'
                    ],
                },
                content8: {
                    title: 'Curriculum',
                    warn: 'El archivo debe pesar menos de',
                    types: 'Tipos de archivos admitidos:'
                },
                content9: 'ENVIAR',
                content10: 'Oportunidades actuales',
                content11: {
                    country: 'Colombia -',
                    position: 'Gerente Comercial',
                    link: 'Current Openings'
                },
                content12: ''
            },
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/PmCareersIndex.vue